module.exports = __webpack_public_path__ + "static/predictivepoem 30-01-236d878fcc629e629f7c832fd932ba3e.jpg";